<template>
    <el-dialog title="备注" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false"
               :close-on-press-escape="false" width="30%">
        <el-form size="small" ref="order" :model="order" label-width="100px">

          <el-form-item label="备注内容" prop="remark" :rules="[{required: true,message: '请填写备注信息'}]">
            <el-input v-model="remark" class="max-w460"></el-input>
          </el-form-item>

        </el-form>

        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible">取 消</el-button>
            <el-button type="primary" @click="submitFunc()" :loading="loading">保存</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import OrderApi from '@/api/order.js';
    export default {
        data() {
            return {
                order_id: 0,
                loading: false,
                /*左边长度*/
                formLabelWidth: '100px',
                /*是否显示*/
                dialogVisible: true,
                remark:''
            };
        },
        props: ['dataModel'],
        created() {
            this.remark = this.dataModel.remark
        },
        methods: {
            /*确认事件*/
            submitFunc(e) {
                let self = this;
                let remark = this.remark;
                self.loading = true;
                OrderApi.addremark({
                    remark: remark,
                        order_id: this.dataModel.order_id
                    },
                    true
                    ).then(data =>
                {
                    self.loading = false;
                    self.$message({
                        message: '操作成功',
                        type: 'success'
                    });
                    self.dialogFormVisible();
                }).catch(error =>
                {
                    self.loading = false;
                });
            },
            getCommoditys(e){
              let self = this;
              if (e === 1) {
                self.loading = false;
                self.shipment_commodity_rules = [];
                return;
              }
              self.shipment_commodity_rules = [{type: 'array',required: true,message: '请选择发货商品', trigger: 'change'}];
              OrderApi.getCommodity({
                order_id: this.dataModel.order_id
              }, true)
                .then(data => {
                  self.loading = false;
                  self.shipment_commodity = data.data.list;
                })
                .catch(error => {
                  self.loading = false;
                });
            },


            /*关闭弹窗*/
            dialogFormVisible() {
                this.$emit('closeDialog', {openDialog: false});
            }
        }
    };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/order/order/dialog/Remark.vue